//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { dateFormat } from '@/utils';
import LazyImage from '@/components/common/LazyImage.vue';
export default {
  name: 'Notice',
  components: {
    LazyImage: LazyImage
  },
  props: {
    notice: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    format: function format() {
      if (this.notice.deadLine) {
        return dateFormat(this.notice.deadLine, 'yyyy-MM-dd hh:mm');
      } else {
        return null;
      }
    }
  }
};